export const formatDatetime = (dataTime?: number, isReturnString?: boolean) => {
  const now = dataTime ? new Date(dataTime) : new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const second = now.getSeconds();

  return {
    year,
    month: month < 10 ? "0" + month : month,
    day: day < 10 ? "0" + day : day,
    hour: hour < 10 ? "0" + hour : hour,
    minute: minute < 10 ? "0" + minute : minute,
    second: second < 10 ? "0" + second : second,
  };
};

export const formatHumanTime = (seconds: number) => {
  const Hours = Math.floor(seconds / 3600);
  const Minutes = Math.floor((seconds - Hours * 3600) / 60);
  // const Seconds = seconds - Hours * 3600 - Minutes * 60;

  // 使用字符串模板来格式化输出结果
  const hh = Hours.toString().padStart(2, "0");
  const mm = Minutes.toString().padStart(2, "0");
  // const ss = Seconds.toString().padStart(2, "0");
  return `${Hours ? hh + "h" : ""} ${Minutes ? mm + "min" : ""}`;
};

export const getBrowserInfo = () => {
  const u = navigator.userAgent;
  const match = {
    // 内核
    Trident: u.indexOf("Trident") > 0 || u.indexOf("NET CLR") > 0,
    Presto: u.indexOf("Presto") > 0,
    WebKit: u.indexOf("AppleWebKit") > 0,
    Gecko: u.indexOf("Gecko/") > 0,
    // 浏览器
    UC: u.indexOf("UC") > 0 || u.indexOf(" UBrowser") > 0,
    // QQ: u.indexOf('QQBrowser')>0,
    BaiDu: u.indexOf("Baidu") > 0 || u.indexOf("BIDUBrowser") > 0,
    Maxthon: u.indexOf("Maxthon") > 0,
    LBBROWSER: u.indexOf("LBBROWSER") > 0,
    SouGou: u.indexOf("MetaSr") > 0 || u.indexOf("Sogou") > 0,
    IE: u.indexOf("MSIE") > 0 || u.indexOf("Trident") > 0,
    Firefox: u.indexOf("Firefox") > 0,
    Opera: u.indexOf("Opera") > 0 || u.indexOf("OPR") > 0,
    Safari: u.indexOf("Safari") > 0,
    Chrome: u.indexOf("Chrome") > 0 || u.indexOf("CriOS") > 0,
    Wechat: u.indexOf("MicroMessenger") > 0,
    // 系统或平台
    Windows: u.indexOf("Windows") > 0,
    Linux: u.indexOf("Linux") > 0,
    Mac: u.indexOf("Macintosh") > 0,
    Android: u.indexOf("Android") > 0 || u.indexOf("Adr") > 0,
    WP: u.indexOf("IEMobile") > 0,
    BlackBerry:
      u.indexOf("BlackBerry") > 0 ||
      u.indexOf("RIM") > 0 ||
      u.indexOf("BB") > 0,
    MeeGo: u.indexOf("MeeGo") > 0,
    Symbian: u.indexOf("Symbian") > 0,
    iOS: u.indexOf("like Mac OS X") > 0,
    iPhone: u.indexOf("iPh") > 0,
    iPad: u.indexOf("iPad") > 0,
    // 设备
    Mobile:
      u.indexOf("Mobi") > 0 || u.indexOf("iPh") > 0 || u.indexOf("480") > 0,
    Tablet:
      u.indexOf("Tablet") > 0 ||
      u.indexOf("iPad") > 0 ||
      u.indexOf("Nexus 7") > 0,
  };
  // 修正
  if (match.Chrome) {
    match.Chrome = !(
      match.Opera ||
      match.BaiDu ||
      match.Maxthon ||
      match.SouGou ||
      match.UC ||
      match.LBBROWSER
    );
  }
  if (match.Safari) {
    match.Safari = !(
      match.Chrome ||
      match.Opera ||
      match.BaiDu ||
      match.Maxthon ||
      match.SouGou ||
      match.UC ||
      match.LBBROWSER
    );
  }
  if (match.Mobile) {
    match.Mobile = !match.iPad;
  }
  // 基本信息
  const infos = {
    engine: ["WebKit", "Trident", "Gecko", "Presto"],
    browser: [
      "Chrome",
      "IE",
      "Firefox",
      "Opera",
      "Safari",
      "UC",
      "BaiDu",
      "Maxthon",
      "SouGou",
      "LBBROWSER",
      "Wechat",
    ],
    os: [
      "Windows",
      "Linux",
      "Mac",
      "Android",
      "iOS",
      "iPhone",
      "iPad",
      "WP",
      "BlackBerry",
      "MeeGo",
      "Symbian",
    ],
    device: ["Mobile", "Tablet"],
  };

  const version = {
    Chrome: () => {
      return u.replace(/^.*Chrome\/([\d.]+).*$/, "$1");
    },
    IE: () => {
      let v = u.replace(/^.*MSIE ([\d.]+).*$/, "$1");
      if (v == u) {
        v = u.replace(/^.*rv:([\d.]+).*$/, "$1");
      }
      return v != u ? v : "";
    },
    Firefox: () => {
      return u.replace(/^.*Firefox\/([\d.]+).*$/, "$1");
    },
    Safari: () => {
      return u.replace(/^.*Version\/([\d.]+).*$/, "$1");
    },
    Maxthon: () => {
      return u.replace(/^.*Maxthon\/([\d.]+).*$/, "$1");
    },
    BaiDu: () => {
      return u.replace(/^.*BIDUBrowser[\s.]([\d.]+).*$/, "$1");
    },
    UC: () => {
      return u.replace(/^.*UBrowser\/([\d.]+).*$/, "$1");
    },
    Wechat: () => {
      return u.replace(/^.*MicroMessenger\/([\d.]+).*$/, "$1");
    },
  };

  type TBrowserInfo = {
    engine: string;
    browser: string;
    os: string;
    version: string;
    device?: string;
  };

  type TInfosKey = keyof typeof infos;
  type TMatchKey = keyof typeof match;
  type TVersionKey = keyof typeof version;

  const browserInfo: TBrowserInfo = {
    browser: "",
    engine: "",
    os: "",
    version: "",
    device: "",
  };

  for (const info in infos) {
    for (const key in infos[info as TInfosKey]) {
      const value = infos[info as TInfosKey][key];
      if (match[value as TMatchKey]) {
        browserInfo[info as TInfosKey] = value;
      }
      // browser 有值时同时赋值 version 值
      if (browserInfo.browser && version[browserInfo.browser as TVersionKey]) {
        browserInfo.version = version[browserInfo.browser as TVersionKey]();
      }
    }
  }

  return browserInfo;
};

export function browserType(): string {
  return getBrowserInfo().browser;
}

export function replaceAtIndex(
  str: string,
  pattern: string,
  replacement: string,
  i: number
) {
  const lhs = str.substring(0, i);
  const rhs = str.substring(i + pattern.length, str.length);
  return lhs + replacement + rhs;
}

export function strReplaceLast(
  str: string,
  pattern: string,
  replacement: string
) {
  const i = str.lastIndexOf(pattern);
  if (i < 0) return str;
  return replaceAtIndex(str, pattern, replacement, i);
}

export const isGameHtml = () => {
  return window.location.href.indexOf("GameWindow") > -1;
};

const isSupportWebRtc =
  window.RTCPeerConnection ||
  (window as any).mozRTCPeerConnection ||
  (window as any).webkitRTCPeerConnection;

const isOverChrome57 = function () {
  const uaLowerCase = navigator.userAgent.toLowerCase();
  const version = uaLowerCase.match(/chrome\/([\d]+)/);

  return version ? Number(version[1]) > 57 : false;
};
const isOverSafari11 = () => {
  const browserInfo = getBrowserInfo();
  const browserName = browserInfo.browser;
  const browserVersion = parseInt(browserInfo.version);

  return browserName === "Safari" && browserVersion > 11;
};
// 支持webrtc chrom>57 safari>11
export const isSupportPlay =
  isSupportWebRtc && (isOverChrome57() || isOverSafari11());

// 保留小数（位）
export const formatFloatNum = (num: number, subNum = 2): number => {
  const idx = num.toString().indexOf(".");
  const int = Math.trunc(num);
  if (~idx) {
    return parseFloat(`${int}${num.toString().slice(idx, idx + subNum + 1)}`);
  }
  return int;
};

// 节流函数
export const throttle = (fn: any, delay = 300): any => {
  let timer: any = null;
  return (...args: any[]) => {
    if (timer === null) {
      timer = setTimeout(() => {
        fn(...args);
        clearTimeout(timer);
        timer = null;
      }, delay);
    }
  };
};

// 防抖
export const debounce = (fn: any, delay = 300) => {
  let timer: any = null;
  return (...args: any[]) => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

export function formatGameTimeWithSecond(second: number): string {
  const hh: number = Math.floor(second / 3600);
  const mm: number = Math.floor((second - hh * 3600) / 60);
  const ss: number = Math.floor((second - hh * 3600) % 60);
  const runningTime: string =
    `${hh < 10 ? "0" + hh : hh}` +
    ":" +
    `${mm < 10 ? "0" + mm : mm}` +
    ":" +
    `${ss < 10 ? "0" + ss : ss}`;
  return runningTime;
}

/**
 * 获取URL参数
 *
 * @param {*} name
 * @returns
 * unescape 已废除
 * https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/unescape
 */
export function getQueryString(name: string) {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);

  const hash = window.location.hash;
  if (hash.indexOf("?") > 0) {
    const searchInHash = hash.substr(hash.indexOf("?") + 1);
    r = searchInHash.match(reg);
    if (r != null) return decodeURIComponent(r[2]);
  }
  return null;
}
